export const setIsProPlan = (user:any, plans:any, toggleUserPro:any) => {
    let userPlanId = user.data.current_plan;
    let plansCount = plans.items.length;
    for(let i = 0; i < plansCount; i++){
        let currentPlan = plans.items[i];
        if(currentPlan.id === userPlanId && currentPlan.price > 0){
            toggleUserPro(true);
        }
    }
};